





























































































































































































































































































































































































































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { productUnitPanel,imageDialog, selectClassPanel, addClassPanel, NumberKeyboard, selectSpecsPanel, supplierPanel, addSupplierPanel, logoutPanel, batchSettings, printLabelPanel } from "@/components";
import { TbGoods, TbGoodsClass, TbGoodsSpecs, TbSettingsPad, TbSupplier } from '@/http';
import { ImagePreview, Toast, Dialog } from 'vant';
import { default as aliupload } from '@/common/util/ossUploadServicePad';
import calculate from '@/common/util/calculate';
const { userAgent } = navigator;
const isAndroid =
    userAgent.indexOf("Android") > -1 ||
    userAgent.indexOf("android") > -1 ||
    userAgent.indexOf("Adr") > -1; // android终端
@Component({
    components: {
        imageDialog,productUnitPanel, selectClassPanel, addClassPanel, NumberKeyboard, selectSpecsPanel, supplierPanel, addSupplierPanel, logoutPanel, batchSettings, printLabelPanel
    },
})
export default class productDetail extends Vue {
    public $refs: {
        imageDialog:HTMLFormElement;
        barcode:HTMLFormElement;
    };
    @Prop({
        default: false
    })
    isEdit: Boolean;
    @Prop({
        default: "add"
    })
    type: String;
    @Prop({
        default: ""
    })
    editId: String;

    form: any = {
        articleNo: "",
        goodsUnit: null,
        name: "",
        goodsClassId: "",
        costPrice: null,
        sellingPrice: null,
        goodsImgUrl: "",
        goodsDesc: "",
        isMemberDiscount: true,
        isIntegral: true,
        isDiscount: true,
        supplierName: "",
        supplierId: "",
        goodsSpecsIds: "",
        safetyLevel: "",
        material: "",
        washingMethod: "",
        qualityLevel: "",
        standard: "",
        goodDiscount: null,
        discountPrice: null,
    }
    /**商品状态下拉 */
    showUnitPopover = false;

    /**商品分类列表 */
    classList = [];
    checkClassId = [];
    checkClassName = [];
    goodsClassName = "";

    /**新增分类弹窗 */
    /**新增分类类型
     * true：一级分类
     * false：二级分类
     */
    isParent = true;

    addClassShow = false;
    /**一级分类信息 */
    firstInfo: any = {};

    //扫码的69码等
    screenCode = '';

    get unitName() {
        let str = "";
        str = this.unitindex2name(this.form.goodsUnit);
        return str;
    }
    /**选择商品单位 */
    async changeUnitXL(item, index) {
        this.form.goodsUnit = item.value;
        this.showUnitPopover = false;
    }

    /**选择规格 */
    specsSelectedList = [];
    /**编辑带来的 */
    oldSpecsSelectedList = [];
    oldAddGoodsItemsList = [];
    addGoodsItemsList = [
        {
            barCode: '',
            goodsSpecsId: '',
            goodsSpecsName: '-/-',
            stock: 1,
            isShelves: true,
            tick: true,
            parentId: "",
            updateType:1,
        }
    ];
    isAutoPrint = true;

    userInfo: any = {};

    /**商品折扣价 */
    discountOptions = [
        {
            label: '打折',
            value: 1
        },
        {
            label: '一口价',
            value: 2
        },
    ]
    discountVal = 1;
    showDiscountPopover = false;

    isLoading = false;

    hasClass = true;

    /**提示弹窗 */
    tipShow = false;
    tipTitle = "";
    tipText = "";
    confirmText = "";
    cancelText = "";
    btnNums = 1;
    tipType = 1;
    tipItem: any = {};

    oldInfo = {
        oldSpecsSelectedList: [],
        addGoodsItemsList: [],
    }

    printShow = false;
    savetype = null;
    goodsId = "";
    goodForm: any = {};

    sTxt = "***"
    sTxt2 = "***.**"

    isScaning = false;
    //69若存在的id
    existGoodsid = '';

    get getDiscountName() {
        let str = "";
        str = this.discountOptions.find(v => v.value == this.discountVal).label;
        return str;
    }

    get totalStock() {
        let val = 0;
        if (this.addGoodsItemsList.filter(vv => vv.stock > 0)) {
            let arr = this.addGoodsItemsList.map(v => v.stock);
            val = arr.reduce((a, b) => Number((Number(a) + Number(b)).toFixed(0)))
        }
        return val;
    }

    created() {
        this.userInfo = JSON.parse(localStorage.getItem("padUserinfo"))
    }

    async mounted() {
        this.getSupplierList()
        var input = document.querySelector("input[type=file]");
        input.addEventListener("change", (e) => {
            var file = e.target.files[0];
            var reader = new FileReader();
            reader.onload = (e) => {
                var dataURL = e.target.result;
                let size = e.total / 1024 / 1024;
                if (size > 5) {
                    Toast("请上传图片大小不可大于5M")
                    $(`#goodsimg`).val('');
                    return;
                }
                aliupload().uploadStream(dataURL, res => {
                    if (res.url) {
                        this.form.goodsImgUrl = res.url;
                    }
                })

            };
            reader.readAsDataURL(file);
        });

        await this.getClassList();
        if (this.type == 'add') {
            /**获取上一次新增商品信息 */
            let res = await TbGoods.GetTbGoodsList({
                isShelves: true,
                isStock: false,
                shopId: this.userInfo.shopId,
                timeSort: 0,
                saleSort: 0,
                stockSort: 0,
                skip: 0,
                count: 1,
            });
            let resSetting = await TbSettingsPad.GetTbSettings({ settingtype: 11 });
            let initInfo = resSetting.settingContent;
            let lastInfo =
                res.items.length > 0
                    ? res.items[0]
                    : {
                        name: "",
                        goodsUnit: 1,
                        goodsClassId: "",
                        goodsClassName: "",
                        isIntegral: true,
                        isMemberDiscount: true,
                        isDiscount: true,
                        supplierId: "",
                        supplierName: "",
                        goodDiscount: null,
                    };
            switch (initInfo.goodsNameSet) {
                case null:
                    this.form.name = "";
                    break;
                case false:
                    this.form.name = lastInfo.name;
                    break;
                case true:
                    this.form.name = initInfo.goodsName ? initInfo.goodsName.value : ""
                    break;

                default:
                    break;
            }
            switch (initInfo.goodsUnitSet) {
                case null:
                    this.form.goodsUnit = "";
                    break;
                case false:
                    this.form.goodsUnit = lastInfo.goodsUnit;
                    break;
                case true:
                    this.form.goodsUnit = initInfo.goodsUnit ? Number(initInfo.goodsUnit.value) : ""
                    break;

                default:
                    break;
            }
            switch (initInfo.goodsClassSet) {
                case null:
                    this.form.goodsClassId = "";
                    break;
                case false:
                    this.form.goodsClassId = lastInfo.goodsClassId;
                    break;
                case true:
                    this.form.goodsClassId = initInfo.goodsClass ? initInfo.goodsClass.value : ""
                    break;

                default:
                    break;
            }
            this.getClassName();

            switch (initInfo.integralSet) {
                case false:
                    this.form.isIntegral = lastInfo.isIntegral;
                    break;
                case true:
                    this.form.isIntegral = initInfo.integral ? this.getResult(initInfo.integral.isSelect) : true;
                    break;

                default:
                    break;
            }

            switch (initInfo.memberDiscountSet) {
                case false:
                    this.form.isMemberDiscount = lastInfo.isMemberDiscount;
                    break;
                case true:
                    this.form.isMemberDiscount = initInfo.memberDiscount ? this.getResult(initInfo.memberDiscount.isSelect) : true;
                    break;

                default:
                    break;
            }

            switch (initInfo.discountSet) {

                case false:
                    this.form.isDiscount = lastInfo.isDiscount;
                    break;
                case true:
                    this.form.isDiscount = initInfo.discount ? this.getResult(initInfo.discount.isSelect) : true;
                    break;

                default:
                    break;
            }

            let supplierList = await TbSupplier.GetTbSupplierDropList();
            switch (initInfo.supplierSet) {
                case null:
                    this.form.supplierId = "";
                    break;
                case false:
                    this.form.supplierId = lastInfo.supplierId;
                    break;
                case true:
                    this.form.supplierId = initInfo.supplier ? initInfo.supplier.value : "";
                    break;

                default:
                    break;
            }

            this.form.supplierName = this.form.supplierId
                ? supplierList.find((v) => v.id == this.form.supplierId).name
                : "";

            switch (initInfo.goodsDiscountSet) {
                case null:
                    this.form.goodDiscount = null;
                    break;
                case false:
                    this.form.goodDiscount = lastInfo.goodDiscount;
                    break;
                case true:
                    this.form.goodDiscount = initInfo.goodsDiscount ? initInfo.goodsDiscount.value : null;
                    break;

                default:
                    break;
            }

            this.discountVal = this.form.goodDiscount ? 1 : 2;



        } else {
            await this.getDetail();
        }

        this.getInputFocus()
        document.addEventListener('click', this.chargeInputFocus)
    }
    chargeInputFocus(event) {
        if (event.target.tagName.toLowerCase() != 'input') {
            this.getInputFocus()
        }
    }
    getInputFocus(){
        this.$nextTick(()=>{
            this.$refs['barcode'].select()
            document.addEventListener('keydown', this.handleScanCode)
        })
    }
    beforeDestroy() {
        document.removeEventListener('keydown',this.handleScanCode) //离开当前路由，会直接调用beforeDestroy方法销毁回车事件
        document.removeEventListener('click', this.chargeInputFocus)
    }
    public scanCodes:any = ''
   /**
     * 监听扫码枪输入
     */
    async handleScanCode(event) {
        if (event.key === 'Backspace' || event.keyCode === 8) {
        // 允许退格键的默认行为
        return;
        }
        if (event.key === 'Enter' || event.keyCode == 13) {
            console.log('event',event)
            console.log('查询123',this.scanCodes)
            if(this.scanCodes || this.isScanCode){
                let code = this.scanCodes?this.scanCodes:event.target.value
                await this.scanInput(code);
            }

            this.scanCodes = ''
        return
        }
    }
    isScanCode= false
    getFocus(){
        this.isScanCode = true
    }
    async inputBlur() {
        this.isScanCode = false
        
        document.addEventListener('click', this.chargeInputFocus)
    }
    async scanInput(val) {
        console.log('扫描69码');
        if (this.type == 'edit') return;
        let reszzz = await TbGoods.BarCodeQuery({
            code: val
        });
        console.log('reszzz', reszzz);
        // 已存在
        if (reszzz.goodsId) {
            this.existGoodsid = reszzz.goodsId;
            this.tipTitle = "操作提醒";
            this.tipText = `${reszzz.code}商品已存在，是否查看`;
            this.btnNums = 2;
            this.confirmText = "去查看";
            this.cancelText = "取消"
            this.tipType = 2;
            this.tipShow = true;
        } else {
            this.screenCode = reszzz.code ? reszzz.code : val;
            console.log("this.screenCode-=-=-==-=", this.screenCode);
            this.specsSelectedList = [];
            this.addGoodsItemsList = [{
                barCode: this.screenCode,
                goodsSpecsId: '',
                goodsSpecsName: '-/-',
                stock: 1,
                isShelves: true,
                tick: true,
                parentId: '',
                updateType:1,
            }]
            this.form.name = reszzz.goodsName ? reszzz.goodsName : '';
            this.form.sellingPrice = reszzz.price ? reszzz.price : null;
            this.form.supplierName = reszzz.manuName ? reszzz.manuName : '';
            if (reszzz.manuName) {
                let res_suplist = await TbSupplier.GetTbSupplierDropList();
                this.form.supplierId = res_suplist.find((v) => v.name == reszzz.manuName) ? res_suplist.find((v) => v.name == reszzz.manuName).id : '';
            }
        }
    }

    async getDetail() {
        let res = await TbGoods.GetTbGoodsById({
            id: this.editId
        });
        this.form = res;
        this.addGoodsItemsList = res.getGoodsItemsList.map(v => {
            return {
                ...v,
                updateType: 2,
            }
        });
        this.oldAddGoodsItemsList = res.getGoodsItemsList;
        if (res.goodsSpecsIds) {
            this.getInitGGListU(res.goodsSpecsIds)
        }
        this.getClassName();
        this.discountVal = this.form.goodDiscount ? 1 : 2;

    }

    async getInitGGListU(ids) {
        let res = await TbGoodsSpecs.GetTbGoodsSpecsList();
        let arr = ids.split(',');
        let selectArr = res.filter(v => arr.findIndex(j => j == v.id) > -1);
        selectArr = selectArr.map(v => {
            return {
                ...v,
                index: arr.findIndex(j => j == v.id)
            }
        })
        /**按照specid排序，不然对不上 */
        selectArr.sort((a, b) => a.index - b.index);
        // console.log('selectArr',selectArr);
        this.specsSelectedList = selectArr.map((v, index) => {
            return {
                id: v.id,
                name: v.name,
                childList: index == 0 ? v.specsItemsJson.filter(j => this.form.itemSpecsIds1.split(',').findIndex(fi => fi == j.id) > -1).map(jj => {
                    return {
                        ...jj,
                        parentId: v.id
                    }
                }) :
                    v.specsItemsJson.filter(j => this.form.itemSpecsIds2.split(',').findIndex(fi => fi == j.id) > -1).map(jj => {
                        return {
                            ...jj,
                            parentId: v.id
                        }
                    })


            }
        })
        // console.log('specsSelectedList',this.specsSelectedList);

        this.oldSpecsSelectedList = this.specsSelectedList;

    }


    /**商品单位弹窗 */
    showUnit() {
        this.$refs['productUnitPanel'].showFun(this.unitName);
    }
    unitConfirm(val) {
        this.form.goodsUnit = val;
    }
    statusOptions = [
        {
            label: "件",
            value: 1,
        },
        {
            label: "条",
            value: 2,
        },
        {
            label: "套",
            value: 3,
        },
        {
            label: "只",
            value: 4,
        },
        {
            label: "双",
            value: 5,
        },
        {
            label: "盒",
            value: 6,
        },
        {
            label: "台",
            value: 7,
        },
        {
            label: "袋",
            value: 8,
        },
        {
            label: "个",
            value: 9,
        },
        {
            label: "包",
            value: 10,
        },
        {
            label: "桶",
            value: 11,
        },
        {
            label: "卷",
            value: 12,
        },
        {
            label: "打",
            value: 13,
        },
        {
            label: "副",
            value: 14,
        },
    ]
    unitindex2name(index) {
        switch (index) {
            case 1:
                return '件';
            case 2:
                return '条';
            case 3:
                return '套';
            case 4:
                return '只';
            case 5:
                return '双';
            case 6:
                return '盒';
            case 7:
                return '台';
            case 8:
                return '袋';
            case 9:
                return '个';
            case 10:
                return '包';
            case 11:
                return '桶';
            case 12:
                return '卷';
            case 13:
                return '打';
            case 14:
                return '副';
            default:
                return "";
        }
    }
    /**商品分类弹窗 */
    showClass() {
        this.$refs['selectClassPanel'].showFun(this.form.goodsClassId);
    }
    chooseClass(item) {
        this.form.goodsClassId = item.id;
        this.goodsClassName = item.name;
    }
    async getClassList() {
        let res = await TbGoodsClass.GetAllGoodsClassList({
            needGoodsCount: false
        })
        this.classList = res;
    }
    /**递归搜索结果 */
    async mapClassId(data) {
        data.map((v) => {
            if (v.items && v.items.length > 0) {
                this.mapClassId(v.items);
            }
            if (this.form.goodsClassId.indexOf(",") == -1) {
                if (this.form.goodsClassId == v.id) {
                    this.checkClassId.push(v.id);
                    this.checkClassName.push(v.name);
                }
            } else {
                let arr = this.form.goodsClassId.split(",")
                if (arr.some(k => k == v.id)) {
                    this.checkClassId.unshift(v.id);
                    this.checkClassName.unshift(v.name);
                }

            }
        });

    }
    closeFun() {
        this.addClassShow = false;
    }
    async confirmSave(res) {
        let id = res.childId ? res.id + ',' + res.childId : res.id;
        this.form.goodsClassId = id;
        await this.getClassList();
        await this.getClassName();
        this.$refs['selectClassPanel'].closeFun();
    }
    /**匹配分类名 */
    async getClassName() {
        this.checkClassId = [];
        this.checkClassName = [];
        await this.mapClassId(this.classList);
        if ((this.form.goodsClassId.indexOf(",") == -1 && this.checkClassId.length > 0) || (this.form.goodsClassId.indexOf(",") > -1 && this.checkClassId.length == 2)) {
            this.goodsClassName = this.checkClassName.join('-');

        } else {
            this.form.goodsClassId = this.classList.some(v => v.name == '其他分类') ? this.classList.find(v => v.name == '其他分类').id : '';
            this.goodsClassName = "其他分类";

        }
    };
    async chargeClass() {
        this.checkClassId = [];
        this.checkClassName = [];
        await this.mapClassId(this.classList);
        if ((this.form.goodsClassId.indexOf(",") == -1 && this.checkClassId.length > 0) || (this.form.goodsClassId.indexOf(",") > -1 && this.checkClassId.length == 2)) {
            this.hasClass = true;

        } else {
            this.hasClass = false;


        }
    }
    addClass(type) {
        this.isParent = type;
        this.addClassShow = true;
        this.$refs['addClassPanel'].init1(this.isParent);
        if (!type) {
            this.$refs['addClassPanel'].init(this.firstInfo);
        }
    }
    addSecondClass(item) {
        this.firstInfo = item;
        this.addClass(false);
    }
    finishNum(value, type) {
        switch (type) {
            case 1:
                this.form.costPrice = value;
                break;
            case 2:
                this.form.sellingPrice = value;
                break;

            default:
                break;
        }
    }
    finishNum2(value, index) {
        this.$set(this.addGoodsItemsList[index], 'stock', value);
    }
    changeMemerdiscount(val) {
        this.form.isMemberDiscount = val;
    }
    changeIntegral(val) {
        this.form.isIntegral = val;
    }
    changeDiscount(val) {
        this.form.isDiscount = val;
    }
    showSpec() {
        this.$refs['selectSpecsPanel'].showFun(JSON.stringify(this.specsSelectedList));
    }
    specsConfirmChoose(list) {
        this.specsSelectedList = JSON.parse(list);
        this.formateGGList();
    }
    formateGGList() {
        if (this.specsSelectedList.length > 0) {
            // this.addGoodsItemsList= [];
            let oldArr = this.addGoodsItemsList;
            let arr = [];
            if (this.specsSelectedList.length == 1) {
                arr = this.specsSelectedList[0].childList.map(v => {
                    return {
                        barCode: '',
                        goodsSpecsId: v.id,
                        goodsSpecsName: `${v.name}/-`,
                        stock: 1,
                        isShelves: true,
                        tick: true
                    }
                })
            } else {
                let arr1 = this.specsSelectedList[0].childList;
                let arr2 = this.specsSelectedList[1].childList;
                arr1.forEach(j => {
                    arr2.map(v => {
                        arr.push({
                            barCode: '',
                            goodsSpecsId: j.id + ',' + v.id,
                            goodsSpecsName: `${j.name}/${v.name}`,
                            stock: 1,
                            isShelves: true,
                            tick: true
                        })
                    })
                })

            }
            this.addGoodsItemsList = arr.map(v => {
                if (oldArr.findIndex(j => j.parentId == v.parentId && j.goodsSpecsId == v.goodsSpecsId) > -1) {
                    return oldArr.find(j => j.parentId == v.parentId && j.goodsSpecsId == v.goodsSpecsId)
                } else {
                    return {
                        ...v,
                        updateType: 1,
                    }
                }
            });
            console.log('addGoodsItemsList', this.addGoodsItemsList);

        } else {
            this.resetGgList();
        }
    }
    resetGgList() {
        this.addGoodsItemsList = [{
            barCode: '',
            goodsSpecsId: '',
            goodsSpecsName: '-/-',
            stock: 1,
            isShelves: true,
            tick: true,
            parentId: '',
            updateType:1,
        }]
    }
    deleteRow(item) {
        let val = true;
        if (this.type == 'edit') {
            let index = this.oldSpecsSelectedList.findIndex(v => v.id == item.id);
            this.tipTitle = "操作提醒";
            this.tipText = `确定删除该规格吗？`;
            this.btnNums = 2;
            this.confirmText = "确认";
            this.cancelText = "取消"
            this.tipType = 1;
            this.tipItem = item;
            val = true;
            if (index > -1) {
                if (this.addGoodsItemsList.some(v => v.stock && v.stock > 0 && this.oldSpecsSelectedList[index].childList.some(j => v.goodsSpecsId.indexOf(j.id) > -1))) {
                    this.tipText = `该规格下的商品存在库存，无法移除！`;
                    this.confirmText = "我知道了";
                    this.btnNums = 1;
                    this.tipType = 3;
                }

            }
        } else {
            val = false;
        }
        if (val) {
            this.tipShow = true;
            return;
        }
        this.specsSelectedList = this.specsSelectedList.filter(v => v.id != item.id);
        this.formateGGList();
    }
    cDFun(item) {
        this.specsSelectedList = this.specsSelectedList.filter(v => v.id != item.id);
        this.formateGGList();
    }
    /**提示弹窗 */
    async tipConfirm() {
        if (this.tipType == 1) {
            this.cDFun(this.tipItem)
        } else if (this.tipType == 2) {
            this.$router.push("/pad/product/viewProduct?id=" + this.existGoodsid);
        }
        this.tipShow = false;
    }
    tipCancel() {
        this.tipShow = false;
    }
    showSupplierPopover = false
    /**选择供应商 */
    // showSupplier() {
    //     this.$refs['supplierPanel'].showFun(this.form.supplierId);
    // }
    changeSupplierXL(item,index){
        console.log('item',item)
        this.form.supplierId = item.id;
        this.form.supplierName = item.name;
        this.showSupplierPopover = false

    }
    SupplierList:any = []
    async getSupplierList(){
        let res = await TbSupplier.GetTbSupplierDropList();
        this.SupplierList = res;
    }
    supplierConfirm(v) {
        this.form.supplierName = v.name;
        this.form.supplierId = v.id;
    }
    confirmSaveSupplier(v) {
        this.supplierConfirm(v);
    }
    /**新增供应商 */
    addSupplier() {
        // if(!this.hasAuth('2202')){
        //     Toast("暂无新增供应商权限，请联系管理员")
        //     return;
        // }
        this.$refs['addSupplierPanel'].showFun();
    }
    showSTip() {
        Toast("暂无新增供应商权限，请联系管理员")
    }
    showCTip() {
        Toast("缺少进货价设置权限")
    }
    /**判断权限 */
    hasAuth(auth) {
        let val = false;
        let btnPermissionsStr = this.userInfo['authorityJson'].split(',');
        if (btnPermissionsStr == undefined || btnPermissionsStr == null) {
            val = false;
        }
        if (btnPermissionsStr.some(v => v == auth)) {
            val = true;
        }
        return val;
    }
    goback() {
        this.$router.go(-1);
    }
    changeAutoPrint(val) {
        this.isAutoPrint = val;
    }
    changeDiscountXL(item, index) {
        this.discountVal = item.value;
        this.showDiscountPopover = false;
    }
    getResult(val) {
        let res = val == "1" ? true : false;
        return res;
    }
    finishDiscount(val) {
        if (this.discountVal == 1) {
            this.form.goodDiscount = val;
            this.form.discountPrice = null;
        } else {
            this.form.goodDiscount = null;
            this.form.discountPrice = val;
        }
    }
    async saveFun(savetype) {
        if (this.isLoading) return;
        if (!this.form.name) {
            Toast.fail("请输入名称");
            return;
        }
        if (!this.form.goodsUnit) {
            Toast.fail("请选择单位");
            return;
        }
        if (!this.form.goodsClassId) {
            Toast.fail("请选择分类");
            return;
        }
        await this.chargeClass();
        if (!this.hasClass) {
            Toast.fail("分类不存在");
            return;
        }




        /**一口价 */
        if (this.discountVal == 2) {
            if (
                Number(this.form.discountPrice) >
                Number(this.form.sellingPrice)
            ) {
                Toast.fail("折扣价不合法");
                return;
            }
            this.form.goodDiscount = 0;
            this.form.discountPrice =
                this.form.discountPrice != null
                    ? this.form.discountPrice
                    : "";
            if (
                this.form.discountPrice.toString() == "" &&
                this.form.discountPrice.toString() != "0"
            ) {
                this.form.discountPrice = this.form.sellingPrice;
            }
        } else {
            if (Number(this.form.goodDiscount) > 10) {
                Toast.fail("折扣大于10");
                return;
            } else {
                // this.form.discountPrice =
                //     Math.floor(
                //         this.multiplication(
                //             this.form.sellingPrice != null
                //                 ? this.form.sellingPrice
                //                 : 0,
                //             this.form.goodDiscount != null
                //                 ? this.form.goodDiscount * 0.1
                //                 : 1
                //         ) * 100
                //     ) / 100;
                console.log('this.form.discountPrice', this.form.discountPrice);
                let nDiscount = this.form.goodDiscount
                ? calculate.multiplication(this.form.goodDiscount, 0.1)
                : 1;

                this.form.discountPrice = calculate.multiplication(this.form.sellingPrice?this.form.sellingPrice:0, nDiscount);
                
            }
            if (
                this.form.goodDiscount == 0 ||
                this.form.goodDiscount == null || this.form.goodDiscount == ''
            ) {
                this.form.goodDiscount = 10;
                this.form.discountPrice = this.form.sellingPrice;
            }
        }
        this.isLoading = true;

        this.addGoodsItemsList = this.addGoodsItemsList.map(v => {
            return {
                ...v,
                shopId: this.userInfo.shopId
            }
        })
        this.form.sellingPrice = this.form.sellingPrice
            ? this.form.sellingPrice
            : 0;


        this.form.costPrice = this.form.costPrice
            ? this.form.costPrice
            : 0;
        this.form.goodDiscount = this.form.goodDiscount
            ? this.form.goodDiscount
            : 0;


        if (this.type == 'add') {
            this.goodsId = "";
            this.goodForm = {};
            this.savetype = savetype;
            let obj = Object.assign({}, this.form, {
                goodsClassName: this.goodsClassName,
                source: 1,
                shopId: this.userInfo.shopId,
                goodsSpecsIds: this.specsSelectedList.length > 0 ? this.specsSelectedList.map(v => v.id).join(',') : '',
                totalStock: this.totalStock,
                isShelves: true,
                itemSpecsIds1: this.getitemSpecsIds(1),
                itemSpecsIds2: this.getitemSpecsIds(2),
                addGoodsItemsList: this.addGoodsItemsList,
                discountPrice: this.form.discountPrice ? this.form.discountPrice : 0,
            })
            console.log('obj', obj);
            try {
                let res = await TbGoods.PostAddTbGoodsV2(obj);
                this.goodsId = res.goodsId;
                this.isLoading = false;
                if (savetype) {
                    if(this.isAutoPrint){
                        this.showPrint();
                    }else{
                        this.$router.go(-1)
                    }
                    // this.$router.go(-1)
                } else {
                    if(this.isAutoPrint){
                        this.showPrint();
                    }else{
                        location.reload();
                    }
                    // location.reload();
                }
            } catch (error) {
                this.isLoading = false;

            }
        } else if (this.type == 'edit') {
            console.log('addGoodsItemsList', this.addGoodsItemsList);
            let arr = this.addGoodsItemsList.filter(v => v.updateType && v.updateType == 2);
            let deleteList = this.oldAddGoodsItemsList.filter(v => arr.findIndex(j => j.id == v.id) == -1);
            if (deleteList.length > 0) {
                deleteList = deleteList.map(v => {
                    return {
                        ...v,
                        updateType: 3
                    }
                })
            }
            let newArr = this.addGoodsItemsList.concat(deleteList);

            let obj = Object.assign({}, this.form, {
                goodsClassName: this.goodsClassName,
                source: 1,
                goodsSpecsIds: this.specsSelectedList.length > 0 ? this.specsSelectedList.map(v => v.id).join(',') : '',
                totalStock: this.totalStock,
                isShelves: true,
                itemSpecsIds1: this.getitemSpecsIds(1),
                itemSpecsIds2: this.getitemSpecsIds(2),
                addGoodsItemsList: newArr,
                discountPrice: this.form.discountPrice ? this.form.discountPrice : 0,
            })
            try {
                let res = await TbGoods.PutUpdateTbGoods(obj);
                this.isLoading = false;
                this.$router.go(-1)

            } catch (error) {
                this.isLoading = false;

            }

        }




    }
    getitemSpecsIds(type) {
        let str = "";
        if (type == 1) {
            if (this.specsSelectedList.length > 0) {
                str = this.specsSelectedList[0].childList.map(v => v.id).join(',')
            }
        } else {
            if (this.specsSelectedList.length == 2) {
                str = this.specsSelectedList[1].childList.map(v => v.id).join(',')
            }
        }
        return str;
    }



    multiplication(arg1, arg2) {
        let m = 0,
            s1 = arg1.toString(),
            s2 = arg2.toString();
        try {
            m += s1.split(".")[1].length;
        } catch (e) { }
        try {
            m += s2.split(".")[1].length;
        } catch (e) { }
        return (
            (Number(s1.replace(".", "")) * Number(s2.replace(".", ""))) /
            Math.pow(10, m)
        );
    }

    /**批量设置 */
    batchSet(val) {
        this.addGoodsItemsList = this.addGoodsItemsList.map(v => {
            return {
                ...v,
                stock: val
            }
        })
    }

    async showPrint() {
        let res = await TbGoods.GetTbGoodsById({
            id: this.goodsId
        });
        this.goodForm = res;
        this.printShow = true;
    }
    closePrintFun() {
        this.printShow = false;
        if (this.savetype) {
            this.$router.go(-1)
        } else {
            location.reload();
        }
    }
    chooseFun(val) {
        $('#' + val).click();
    }
    delImg() {
        this.form.goodsImgUrl = "";
    }
    ImgUrl:string = ''
    /**预览图片 */
    viewImg(url) {
        this.ImgUrl = url
        this.$nextTick(()=>{
            this.$refs.imageDialog.opens()
        })
        // ImagePreview([url]);
    }
    

}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/product/components/productDetail.vue